import { Grid } from "@mui/material";
import Panel from "../../../components/UI/Panel";
import GenericSelectInput from "./UI/GenericSelectInput";
import MultiSelectInput from "./UI/MultiSelectInput";
import Dropdown from "../../../Models/Locations/dropdown";
import CheckboxInput from "./UI/CheckboxInput";


interface ComponentProps {
    formik: any;
    followUpMethods: Dropdown[];
}

const FollowUpMethods = ({
    formik,
    followUpMethods
}: ComponentProps) => {

    const togglePressFollowUpMethods = (r: string) => {
        let followUpMethods = [
            ...formik.values.custodianDetails.followUpMethods,
        ];
        const recordIndex = followUpMethods.indexOf(r);
        if (recordIndex > -1) {
            followUpMethods = followUpMethods.filter((record) => record !== r);
        } else followUpMethods = [...followUpMethods, r];
        formik.setFieldValue(
            `custodianDetails.followUpMethods`,
            followUpMethods,
        );
    };

    return (
        <Panel headerText="Follow Up Methods">
            <Grid spacing={2} mx={1} px={1} container>
                <Grid item xs={4} px={2}>
                    <GenericSelectInput
                        hasError={false}
                        errorMsg=""
                        label="Select Follow Up Methods(s)"
                        name="followUpMethods"
                        onBlur={() => { }}
                        onChange={(r) => {
                            formik.setFieldValue(
                                `custodianDetails.followUpMethods`,
                                r
                            );
                        }}
                        options={followUpMethods}
                        value={formik?.values?.custodianDetails?.followUpMethods}
                        multiple
                    />
                </Grid>
                <Grid item xs={6} pl={3}>
                    <CheckboxInput
                        label='Multiple Status Follow Ups'
                        checked={formik?.values?.custodianDetails?.servePreferences?.isMultipleStatusFollowUps}
                        keyName={`${formik}.values.custodianDetails.servePreferences.isMultipleStatusFollowUps`}
                        onChange={(e: any) => {
                            formik.setFieldValue(
                                `custodianDetails.servePreferences.isMultipleStatusFollowUps`,
                                e.target.checked,
                            );
                        }}
                        onBlur={() => {
                            formik.setFieldTouched(
                                `custodianDetails.servePreferences.isMultipleStatusFollowUps`,
                                true,
                            );
                        }}
                    />
                </Grid>
                <Grid item xs={12} px={2}>
                    <MultiSelectInput
                        options={followUpMethods}
                        errorMsg={formik?.errors?.custodianDetails?.followUpMethods || ''}
                        togglePress={togglePressFollowUpMethods}
                        values={formik?.values?.custodianDetails?.followUpMethods}
                        showOnlySelected 
                    />
                </Grid>
            </Grid>
        </Panel>
    )
}

export default FollowUpMethods